import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortColors'
})
export class SortColorsPipe implements PipeTransform {

  transform(value: Array<any>): any {

    if(value == null) {
      return null;
    }
    return [...value].sort((a, b) => b['name'] - a['name']);
    
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/sort-colors-pipe.ts